<template>
  <OEENYX2 ref="OEENYX2" v-if="formulaNyx && permisoVista('dashboard','r')"/>
  <v-col cols="12" class="px-8" v-else-if="permisoVista('dashboard','r')">
    <v-snackbar v-model="error" top color="error">
      <ul>
        <li v-for="(e, i) in errores" :key="i">{{ e }}</li>
      </ul>
      <v-btn text @click="error = false"> Cerrar </v-btn>
    </v-snackbar>
    
    <v-row class="mt-0" align="end">
      <v-col cols="3" md="3" sm="3">
        <v-select
          v-model="tipoAgrupacion"
          :items="tiposAgrupacion"
          item-value="value"
          item-text="text"
          label="Tipo de Agrupación"
          hide-details
          :disabled="cargando"
          @change="onTipoAgrupacionChange"
        />
      </v-col>
      
      <template v-if="tipoAgrupacion === 'semana'">
        <v-col cols="3" md="3" sm="3" class="pt-0 mt-0">
          <week-picker-calendar
            v-model="semanas"
            :year="2025"
            :month="9"
            :full-weeks-only="true"
            :restrict-year="2025"
            @apply="onAplicar"
          />
        </v-col>
      </template>

      <template v-if="tipoAgrupacion === 'mes'">
        <v-col cols="3" md="3" sm="3" class="pt-0 mt-0">
          <v-autocomplete
            v-model="filtros.mesesSeleccionados"
            :items="mesesDisponibles"
            item-value="value"
            item-text="text"
            label="Meses (Obligatorio)"
            hide-details
            clearable
            multiple
            chips
            deletable-chips
            :disabled="cargando"
          />
        </v-col>
        <v-col cols="3" md="3" sm="3" class="pt-0 mt-0">
          <v-select
            v-model="filtros.año"
            :items="añosDisponibles"
            label="Año"
            hide-details
            :disabled="cargando"
          />
        </v-col>
      </template>
      
      <v-col cols="3" md="3" sm="3" class="pt-0 mt-0">
        <v-autocomplete
          v-model="filtros.idsTurnos"
          :items="turnos"
          item-value="idTurno"
          item-text="nombre"
          label="Turnos (Opcional)"
          hide-details
          clearable
          multiple
          chips
          deletable-chips
          :disabled="cargando"
          @click:clear="resetCampo(1)"
        />
      </v-col>
    </v-row>
    
    <v-row>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-target</v-icon> Filtros Avanzados (Opcionales)
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="4" md="4" sm="4">
                <v-autocomplete
                  v-model="filtros.idsAreas"
                  :items="areas"
                  item-value="idArea"
                  item-text="nombre"
                  label="Áreas"
                  hide-details
                  clearable
                  multiple
                  chips
                  deletable-chips
                  :disabled="cargando"
                  @click:clear="resetCampo(2)"
                />
              </v-col>
              <v-col cols="4" md="4" sm="4">
                <v-autocomplete
                  v-model="filtros.idsOTS"
                  :items="ots"
                  item-value="idTrabajoOrden"
                  item-text="clave"
                  label="Orden de Trabajo"
                  hide-details
                  clearable
                  multiple
                  chips
                  deletable-chips
                  :disabled="cargando"
                  @click:clear="resetCampo(3)"
                />
              </v-col>
              <v-col cols="4" md="4" sm="4">
                <v-autocomplete
                  v-model="filtros.idsArticulos"
                  :items="articulos"
                  item-value="idArticulo"
                  :item-text="nombreArticulo"
                  label="Artículos"
                  hide-details
                  clearable
                  multiple
                  chips
                  deletable-chips
                  :disabled="cargando"
                  @click:clear="resetCampo(4)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="4" sm="4">
                <v-autocomplete
                  v-model="filtros.idsMaquinaInstancias"
                  :items="maquinasIns"
                  item-value="idMaquinaIns"
                  :item-text="nombreMaquina"
                  label="Maquinas Instancias"
                  hide-details
                  clearable
                  multiple
                  chips
                  deletable-chips
                  :disabled="cargando"
                  @click:clear="resetCampo(5)"
                />
              </v-col>
              <v-col cols="4" md="4" sm="4">
                <v-autocomplete
                  v-model="filtros.idsPersonas"
                  :items="operadores"
                  item-value="idPersona"
                  :item-text="nombrePersona"
                  label="Personas"
                  hide-details
                  clearable
                  multiple
                  chips
                  deletable-chips
                  :disabled="cargando"
                  @click:clear="resetCampo(6)"
                />
              </v-col>
              <v-col cols="4" md="4" sm="4">
                <v-autocomplete
                  v-model="filtros.idsClientes"
                  :items="clientes"
                  item-text="nombre"
                  item-value="idCliente"
                  label="Clientes"
                  hide-details
                  clearable
                  multiple
                  chips
                  deletable-chips
                  :disabled="cargando"
                  @click:clear="resetCampo(7)"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    
    <v-row>
      <v-btn color="primary" dark class="mb-2" @click="obtenerDatos">Consultar</v-btn>
      <download-btn
        className="my-4"
        color="blue darken-1"
        text
        @click="descargarReporte"
        label="Descargar Reporte OEE"
      />
    </v-row>
    <br>
    
    <div v-if="viewData">
      <!-- Cards con métricas principales -->
      <v-row v-if="!cargando" class="justify-center ma-0 pa-0">
        <v-col cols="3" md="3" sm="3">
          <v-card class="fill-height d-flex" color="#2a6099" dark>
            <v-card-text class="text-center align-self-center white--text">
              <div class="subtitle-1 font-weight-bold">Disponibilidad</div>
              <ICountUp
                :delay="1000"
                :endVal="datosAgrupados.disponibilidadPromedio"
                class="subtitle-1 font-weight-medium"
                :options="{
                  decimalPlaces: 2,
                  decimal: '.',
                  suffix: '%'
                }"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3" md="3" sm="3">
          <v-card class="fill-height d-flex" color="#2a6099" dark>
            <v-card-text class="text-center align-self-center white--text">
              <div class="subtitle-1 font-weight-bold">Rendimiento</div>
              <ICountUp
                :delay="1000"
                :endVal="datosAgrupados.rendimientoPromedio"
                class="subtitle-1 font-weight-medium"
                :options="{
                  decimalPlaces: 2,
                  decimal: '.',
                  suffix: '%'
                }"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3" md="3" sm="3">
          <v-card class="fill-height d-flex" color="#2a6099" dark>
            <v-card-text class="text-center align-self-center white--text">
              <div class="subtitle-1 font-weight-bold">Calidad</div>
              <ICountUp
                :delay="1000"
                :endVal="datosAgrupados.calidadPromedio"
                class="subtitle-1 font-weight-medium"
                :options="{
                  decimalPlaces: 2,
                  decimal: '.',
                  suffix: '%'
                }"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3" md="3" sm="3">
          <v-card class="fill-height d-flex" color="#2a6099" dark>
            <v-card-text class="text-center align-self-center white--text">
              <div class="subtitle-1 font-weight-bold">OEE</div>
              <ICountUp
                :delay="1000"
                :endVal="datosAgrupados.oeePromedio"
                class="subtitle-1 font-weight-medium"
                :options="{
                  decimalPlaces: 2,
                  decimal: '.',
                  suffix: '%'
                }"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      
      <!-- Gráficas por período -->
      <v-row v-if="!cargando && renderizar">
        <v-col cols="6" md="6" sm="6" class="text-center">
          <div class="text-subtitle-2">Disponibilidad por {{ tipoAgrupacion === 'semana' ? 'Semana' : 'Mes' }}</div>
          <apexchart height="220" :options="serie1" :series="chartOptions1" />
        </v-col>
        <v-col cols="6" md="6" sm="6" class="text-center">
          <div class="text-subtitle-2">Rendimiento por {{ tipoAgrupacion === 'semana' ? 'Semana' : 'Mes' }}</div>
          <apexchart height="220" :options="serie2" :series="chartOptions2" />
        </v-col>
        <v-col cols="6" md="6" sm="6" class="text-center">
          <div class="text-subtitle-2">Calidad por {{ tipoAgrupacion === 'semana' ? 'Semana' : 'Mes' }}</div>
          <apexchart height="220" :options="serie3" :series="chartOptions3" />
        </v-col>
        <v-col cols="6" md="6" sm="6" class="text-center">
          <div class="text-subtitle-2">OEE por {{ tipoAgrupacion === 'semana' ? 'Semana' : 'Mes' }}</div>
          <apexchart height="220" :options="serie4" :series="chartOptions4" />
        </v-col>
      </v-row>
      
      <!-- Tabla de resumen -->
      <v-row v-if="!cargando && renderizar && datosAgrupados.periodos.length > 0">
        <v-col cols="12" md="12" sm="12">
          <v-expansion-panels>
            <v-expansion-panel class="my-2">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon left>mdi-calendar-multiple</v-icon> 
                  Resumen por {{ tipoAgrupacion === 'semana' ? 'Semanas' : 'Meses' }}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headersAgrupados"
                  :items="datosAgrupados.periodos"
                  item-key="id"
                  show-expand
                  fixed-header
                  height="600px"
                  :expanded.sync="expanded"
                >
                  <template v-slot:[`item.disponibilidad`]="{ item }">
                    {{ item.disponibilidad.toFixed(2) }}%
                  </template>
                  <template v-slot:[`item.rendimiento`]="{ item }">
                    {{ item.rendimiento.toFixed(2) }}%
                  </template>
                  <template v-slot:[`item.calidad`]="{ item }">
                    {{ item.calidad.toFixed(2) }}%
                  </template>
                  <template v-slot:[`item.oee`]="{ item }">
                    {{ item.oee.toFixed(2) }}%
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <br>
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center">Total Piezas</th>
                              <th class="text-center">Piezas Teóricas</th>
                              <th class="text-center">Piezas OK</th>
                              <th class="text-center">Piezas No OK</th>
                              <th class="text-center">Tiempo Activo</th>
                              <th class="text-center">Tiempo de Paros</th>
                              <th class="text-center">Scrap</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td class="text-center">{{ item.totalPiezas }}</td>
                              <td class="text-center">{{ item.piezasTeoricas }}</td>
                              <td class="text-center">{{ item.piezasOk }}</td>
                              <td class="text-center">{{ item.piezasNoOk }}</td>
                              <td class="text-center">{{ $utils.strings.toTime(item.tiempoActivo) }}</td>
                              <td class="text-center">{{ $utils.strings.toTime(item.tiempoParos) }}</td>
                              <td class="text-center">{{ (item.scrap * 100).toFixed(2) }}%</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <br>
                    </td>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </div>
    
    <div v-if="cargandoData">
      <v-col cols="12" md="12" sm="12" class="text-center">
        <h4>Cargando</h4>
      </v-col>
      <v-col cols="12" md="12" sm="12" class="text-center">
        <v-progress-circular :size="75" color="green" indeterminate />
      </v-col>
    </div>
  </v-col>
</template>

<script>
import { mapState } from 'vuex';
import axios from "axios";
import ICountUp from "vue-countup-v2";
import moment from "moment";
import DownloadBtn from '../../DownloadBtn.vue';
import OEENYX2 from "./OEENYX2.vue";
import WeekMultiPicker from '../../WeekMultiPicker.vue';
import WeekPickerCalendar from '../../WeekPickerCalendar.vue';

export default {
  components: {
    OEENYX2,
    ICountUp,
    DownloadBtn,
    WeekMultiPicker,
    WeekPickerCalendar
  },
  computed: {
    ...mapState({
      nombreEmpresa: 'nombreEmpresa',
      oeeRendimientoLabel: 'oeeRendimientoLabel',
      nuevoReporteOee: 'nuevoReporteOee',
      formulaNyx: 'formulaNyx',
    }),
    url() {
      // Solo usar endpoint estándar para caso no-NYX
      var endpoint = 'OEERangoTurnos';
      var url = `/OEEV2/${endpoint}?`;
      
      if (this.tipoAgrupacion === 'semana') {
        url += `Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
      } else {
        const { desde, hasta } = this.obtenerRangoFechasMeses();
        url += `Desde=${desde}&Hasta=${hasta}`;
      }
      
      if (this.filtros.idsTurnos != null)
        url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos, "IdsTurnos", false);
      
      url += this.$utils.arrays.urlQuery(this.filtros.idsAreas, "IdsAreas", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsOTS, "IdsOTS", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos, "IdsArticulos", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias, "IdsMaquinasInstancias", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas, "IdsPersonas", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsClientes, "IdsClientes", false);
      
      return url;
    }
  },
  data() {
    return {
      mostrarAviso: true,
      tipoAgrupacion: 'semana',
      tiposAgrupacion: [
        { value: 'semana', text: 'Por Semanas' },
        { value: 'mes', text: 'Por Meses' }
      ],
      mesesDisponibles: [
        { value: 1, text: 'Enero' },
        { value: 2, text: 'Febrero' },
        { value: 3, text: 'Marzo' },
        { value: 4, text: 'Abril' },
        { value: 5, text: 'Mayo' },
        { value: 6, text: 'Junio' },
        { value: 7, text: 'Julio' },
        { value: 8, text: 'Agosto' },
        { value: 9, text: 'Septiembre' },
        { value: 10, text: 'Octubre' },
        { value: 11, text: 'Noviembre' },
        { value: 12, text: 'Diciembre' }
      ],
      añosDisponibles: [],
      cargando: false,
      cargandoData: false,
      semanas: [],
      viewData: false,
      renderizar: false,
      expanded: [],
      error: false,
      errores: [],
      filtros: {
        desde: null,
        hasta: null,
        semanasSeleccionadas: [], // <== [{year, week, desde, hasta, etiqueta}]
        mesesSeleccionados: [],
        año: new Date().getFullYear(),
        idsTurnos: [],
        idsAreas: [],
        idsOTS: [],
        idsArticulos: [],
        idsMaquinaInstancias: [],
        idsPersonas: [],
        idsClientes: []
      },
      turnos: [],
      areas: [],
      ots: [],
      articulos: [],
      maquinasIns: [],
      operadores: [],
      clientes: [],
      datos: {},
      datosAgrupados: {
        disponibilidadPromedio: 0,
        rendimientoPromedio: 0,
        calidadPromedio: 0,
        oeePromedio: 0,
        periodos: []
      },
      serie1: {},
      chartOptions1: [],
      serie2: {},
      chartOptions2: [],
      serie3: {},
      chartOptions3: [],
      serie4: {},
      chartOptions4: [],
      headersAgrupados: [
        {
          text: "Periodo",
          align: "center",
          value: "etiqueta"
        },
        {
          text: "Desde",
          align: "center",
          value: "fechaInicio"
        },
        {
          text: "Hasta",
          align: "center",
          value: "fechaFin"
        },
        {
          text: "Disponibilidad",
          align: "center",
          value: "disponibilidad"
        },
        {
          text: "Rendimiento",
          align: "center",
          value: "rendimiento"
        },
        {
          text: "Calidad",
          align: "center",
          value: "calidad"
        },
        {
          text: "OEE",
          align: "center",
          value: "oee"
        },
        { text: '', value: 'data-table-expand' }
      ]
    };
  },
  methods: {
    onAplicar(weeks) {
      const lista = weeks || this.semanas || [];
      // 1) guarda el rango min–max
      this.setRangeFromWeeks(lista);
      // 2) guarda la selección exacta para que la función pueda filtrar
      this.filtros.semanasSeleccionadas = lista.map(w => ({
        year: w.isoYear,
        week: w.isoWeek,
        desde: w.start,       // 'YYYY-MM-DD'
        hasta: w.end,         // 'YYYY-MM-DD'
        etiqueta: `Sem. ${String(w.isoWeek).padStart(2,'0')} '${String(w.isoYear).slice(-2)}`
      }));
    },
    setRangeFromWeeks(weeks) {
      if (!weeks || !weeks.length) {
        this.filtros.desde = null;
        this.filtros.hasta = null;
        return;
      }
      const starts = weeks.map(w => w.start).sort(); // 'YYYY-MM-DD'
      const ends   = weeks.map(w => w.end).sort();
      this.filtros.desde = starts[0];
      this.filtros.hasta = ends[ends.length - 1];
    },
    nombreArticulo: (articulo) => `[${articulo.codigo}] - ${articulo.nombre}`,
    nombreMaquina: maquina => ` [${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
    nombrePersona: (persona) => persona.nombre + " " + persona.paterno + " " + persona.materno,
      onWeeksChanged() {
      const arr = this.filtros.semanasSeleccionadas;
      if (!arr || arr.length === 0) {
        this.filtros.desde = null;
        this.filtros.hasta = null;
        return;
      }
      const mins = arr.map(x => x.desde).sort()[0];
      const maxs = arr.map(x => x.hasta).sort().slice(-1)[0];
      this.filtros.desde = mins;
      this.filtros.hasta = maxs;
    },
    
onTipoAgrupacionChange() {
  this.filtros.semanasSeleccionadas = [];
  this.filtros.desde = null;
  this.filtros.hasta = null;
  this.semanas = [];
  this.filtros.mesesSeleccionados = [];
  this.viewData = false;
  if (this.tipoAgrupacion === 'semana') this.mostrarAviso = true;
  this.datosAgrupados = {
    disponibilidadPromedio: 0,
    rendimientoPromedio: 0,
    calidadPromedio: 0,
    oeePromedio: 0,
    periodos: []
  };

  if (this.tipoAgrupacion === 'semana') {
    this.mostrarAviso = true;
  }
},


soloDomingos(fecha) {
  return moment(fecha).isoWeekday() === 7;
},

validarFechaDesde(fecha) {
  if (!fecha) return;

  const diaSemana = moment(fecha).isoWeekday();
  if (diaSemana !== 1) {
    const lunes = moment(fecha).startOf('isoWeek').format('YYYY-MM-DD');
    this.filtros.desde = lunes;
  } else {
    this.filtros.desde = moment(fecha).format('YYYY-MM-DD');
  }

  // Llenar automáticamente el domingo de esa semana
  this.filtros.hasta = moment(this.filtros.desde).endOf('isoWeek').format('YYYY-MM-DD');
},

validarFechaHasta(fecha) {
  if (!fecha) return;

  const diaSemana = moment(fecha).isoWeekday();
  if (diaSemana !== 7) {
    const domingo = moment(fecha).endOf('isoWeek').format('YYYY-MM-DD');
    this.filtros.hasta = domingo;
  } else {
    this.filtros.hasta = moment(fecha).format('YYYY-MM-DD');
  }
},


    
    obtenerRangoFechasMeses() {
      if (this.filtros.mesesSeleccionados.length === 0) {
        return { desde: null, hasta: null };
      }
      
      const mesesOrdenados = [...this.filtros.mesesSeleccionados].sort((a, b) => a - b);
      const primerMes = mesesOrdenados[0];
      const ultimoMes = mesesOrdenados[mesesOrdenados.length - 1];
      
      const desde = moment(`${this.filtros.año}-${primerMes}-01`).format('YYYY-MM-DD');
      const hasta = moment(`${this.filtros.año}-${ultimoMes}-01`).endOf('month').format('YYYY-MM-DD');
      
      return { desde, hasta };
    },
    
    agruparDatosPorSemanas(datos) {
      if (!datos || !datos.resumenDias || datos.resumenDias.length === 0) return [];

      const fechaInicio = moment(this.filtros.desde).startOf('isoWeek'); // lunes
      const fechaFin    = moment(this.filtros.hasta).endOf('isoWeek');   // domingo

      const semanas = {};
      let inicioSemana = fechaInicio.clone();

      while (inicioSemana.isSameOrBefore(fechaFin)) {
        const finSemana = inicioSemana.clone().endOf('isoWeek'); // domingo
        const isoYear = inicioSemana.isoWeekYear();
        const isoWeek = inicioSemana.isoWeek();
        const ww = String(isoWeek).padStart(2,'0');

        // etiqueta corta y id sortable por fecha
        const etiqueta = `Sem. ${ww} '${String(isoYear).slice(-2)}`;
        const id = Number(inicioSemana.format('YYYYMMDD'));

        semanas[etiqueta] = {
          id,
          etiqueta,
          fechaInicio: inicioSemana.format('YYYY-MM-DD'),
          fechaFin: finSemana.format('YYYY-MM-DD'),
          dias: [],
          disponibilidad: 0, rendimiento: 0, calidad: 0, oee: 0,
          totalPiezas: 0, piezasTeoricas: 0, piezasOk: 0, piezasNoOk: 0,
          tiempoActivo: 0, tiempoParos: 0, tiempoParoNoPlan: 0, tiempoBruto: 0, scrap: 0
        };

        inicioSemana.add(1, 'week');
      }

      // asigna días
      datos.resumenDias.forEach(dia => {
        const f = moment(dia.fecha);
        Object.values(semanas).forEach(sem => {
          if (f.isBetween(moment(sem.fechaInicio), moment(sem.fechaFin), null, '[]')) {
            sem.dias.push(dia);
          }
        });
      });

      // cálculos
      Object.values(semanas).forEach(sem => {
        if (!sem.dias.length) return;
        sem.totalPiezas     = sem.dias.reduce((s,d)=>s+d.totalPiezas,0);
        sem.piezasTeoricas  = sem.dias.reduce((s,d)=>s+d.piezasTeoricas,0);
        sem.piezasOk        = sem.dias.reduce((s,d)=>s+d.piezasOk,0);
        sem.piezasNoOk      = sem.dias.reduce((s,d)=>s+d.piezasNoOk,0);
        const tBruto        = sem.dias.reduce((s,d)=>s+(d.tiempoBruto*3600),0);
        const tNeto         = sem.dias.reduce((s,d)=>s+(d.tiempoNeto*3600),0);
        const tParos        = sem.dias.reduce((s,d)=>s+(d.tiempoParos*3600),0);
        const tNoPlan       = sem.dias.reduce((s,d)=>s+(d.tiempoParoNoPlan*3600),0);
        sem.tiempoBruto = tBruto; sem.tiempoActivo = tNeto; sem.tiempoParos = tParos; sem.tiempoParoNoPlan = tNoPlan;
        sem.disponibilidad = tBruto>0 ? ((tBruto - tNoPlan)/tBruto)*100 : 0;
        sem.rendimiento    = sem.piezasTeoricas>0 ? (sem.totalPiezas/sem.piezasTeoricas)*100 : 0;
        sem.calidad        = sem.totalPiezas>0 ? (sem.piezasOk/sem.totalPiezas)*100 : 0;
        sem.oee            = (sem.disponibilidad*sem.rendimiento*sem.calidad)/10000;
        sem.scrap          = sem.totalPiezas>0 ? (sem.piezasNoOk/sem.totalPiezas) : 0;
      });

      // lista ordenada por fecha real
      const lista = Object.values(semanas)
        .filter(s => s.dias.length > 0)
        .sort((a,b)=> new Date(a.fechaInicio) - new Date(b.fechaInicio));

      // si hay semanas seleccionadas, filtra
      if (this.filtros.semanasSeleccionadas?.length) {
        const sel = new Set(
          this.filtros.semanasSeleccionadas.map(s => `${s.year}-${String(s.week).padStart(2,'0')}`)
        );
        return lista.filter(s => {
          const y = moment(s.fechaInicio).isoWeekYear();
          const w = String(moment(s.fechaInicio).isoWeek()).padStart(2,'0');
          return sel.has(`${y}-${w}`);
        });
      }

      return lista;
    },
    
    agruparDatosPorMeses(datos) {
      if (!datos || !datos.resumenDias || datos.resumenDias.length === 0) {
        return [];
      }
      
      const meses = {};
      datos.resumenDias.forEach(dia => {
        const fechaDia = moment(dia.fecha);
        const mes = fechaDia.month() + 1;
        const año = fechaDia.year();
        
        if (!this.filtros.mesesSeleccionados.includes(mes) || año !== this.filtros.año) {
          return;
        }
        
        const nombreMes = this.mesesDisponibles.find(m => m.value === mes).text;
        const etiqueta = `${nombreMes} ${año}`;
        
        if (!meses[etiqueta]) {
          meses[etiqueta] = {
            id: mes,
            etiqueta: etiqueta,
            fechaInicio: moment(`${año}-${mes}-01`).format('YYYY-MM-DD'),
            fechaFin: moment(`${año}-${mes}-01`).endOf('month').format('YYYY-MM-DD'),
            dias: [],
            disponibilidad: 0,
            rendimiento: 0,
            calidad: 0,
            oee: 0,
            totalPiezas: 0,
            piezasTeoricas: 0,
            piezasOk: 0,
            piezasNoOk: 0,
            tiempoActivo: 0,
            tiempoParos: 0,
            tiempoParoNoPlan: 0,
            tiempoBruto: 0,
            scrap: 0
          };
        }
        
        meses[etiqueta].dias.push(dia);
      });
      
      // Cálculos para mes - caso NO-NYX (tiempos vienen en horas, convertir a segundos)
      Object.keys(meses).forEach(key => {
        const mes = meses[key];
        if (mes.dias.length > 0) {
          mes.totalPiezas = mes.dias.reduce((sum, dia) => sum + dia.totalPiezas, 0);
          mes.piezasTeoricas = mes.dias.reduce((sum, dia) => sum + dia.piezasTeoricas, 0);
          mes.piezasOk = mes.dias.reduce((sum, dia) => sum + dia.piezasOk, 0);
          mes.piezasNoOk = mes.dias.reduce((sum, dia) => sum + dia.piezasNoOk, 0);
          
          const tiempoBrutoTotal = mes.dias.reduce((sum, dia) => {
            return sum + (dia.tiempoBruto * 3600); // Convertir horas a segundos
          }, 0);
          const tiempoNetoTotal = mes.dias.reduce((sum, dia) => {
            return sum + (dia.tiempoNeto * 3600); // Convertir horas a segundos
          }, 0);
          const tiempoParosTotal = mes.dias.reduce((sum, dia) => {
            return sum + (dia.tiempoParos * 3600); // Convertir horas a segundos
          }, 0);
          const tiempoParoNoPlanTotal = mes.dias.reduce((sum, dia) => {
            return sum + (dia.tiempoParoNoPlan * 3600); // Convertir horas a segundos
          }, 0);
          
          mes.tiempoBruto = tiempoBrutoTotal;
          mes.tiempoActivo = tiempoNetoTotal;
          mes.tiempoParos = tiempoParosTotal;
          mes.tiempoParoNoPlan = tiempoParoNoPlanTotal;

          // Disponibilidad
          mes.disponibilidad = tiempoBrutoTotal > 0 ? 
            ((tiempoBrutoTotal - tiempoParoNoPlanTotal) / tiempoBrutoTotal) * 100 : 0;
          
          // Rendimiento
          mes.rendimiento = mes.piezasTeoricas > 0 ? 
            (mes.totalPiezas / mes.piezasTeoricas) * 100 : 0;
          
          // Calidad
          mes.calidad = mes.totalPiezas > 0 ? 
            (mes.piezasOk / mes.totalPiezas) * 100 : 0;
          
          // OEE
          mes.oee = (mes.disponibilidad * mes.rendimiento * mes.calidad) / 10000;
          
          // Scrap
          mes.scrap = mes.totalPiezas > 0 ? 
            (mes.piezasNoOk / mes.totalPiezas) : 0;
        }
      });
      
      return Object.values(meses).filter(mes => mes.dias.length > 0).sort((a, b) => a.id - b.id);
    },
    
    procesarDatosAgrupados(datos) {
      let periodos = [];

      if (this.tipoAgrupacion === 'semana') {
        periodos = this.agruparDatosPorSemanas(datos);
      } else {
        periodos = this.agruparDatosPorMeses(datos);
      }

      if (periodos.length > 0) {
        const totalPiezasGlobal = periodos.reduce((sum, p) => sum + p.totalPiezas, 0);
        const piezasTeoricasGlobal = periodos.reduce((sum, p) => sum + p.piezasTeoricas, 0);
        const piezasOkGlobal = periodos.reduce((sum, p) => sum + p.piezasOk, 0);
        const piezasNoOkGlobal = periodos.reduce((sum, p) => sum + p.piezasNoOk, 0);
        const tiempoBrutoGlobal = periodos.reduce((sum, p) => sum + p.tiempoBruto, 0);
        const tiempoNetoGlobal = periodos.reduce((sum, p) => sum + p.tiempoActivo, 0);
        const tiempoParosGlobal = periodos.reduce((sum, p) => sum + p.tiempoParos, 0);
        const tiempoParoNoPlanGlobal = periodos.reduce((sum, p) => sum + p.tiempoParoNoPlan, 0);

        const disponibilidadGlobal = tiempoBrutoGlobal > 0 
          ? ((tiempoBrutoGlobal - tiempoParoNoPlanGlobal) / tiempoBrutoGlobal) * 100 
          : 0;

        const rendimientoGlobal = piezasTeoricasGlobal > 0 
          ? (totalPiezasGlobal / piezasTeoricasGlobal) * 100 
          : 0;

        const calidadGlobal = totalPiezasGlobal > 0 
          ? (piezasOkGlobal / totalPiezasGlobal) * 100 
          : 0;

        const oeeGlobal = (disponibilidadGlobal * rendimientoGlobal * calidadGlobal) / 10000;

        this.datosAgrupados = {
          disponibilidadPromedio: disponibilidadGlobal,
          rendimientoPromedio: rendimientoGlobal,
          calidadPromedio: calidadGlobal,
          oeePromedio: oeeGlobal,
          periodos: periodos
        };
      }

      this.generarSeriesAgrupadas();
    },
    
    generarSeriesAgrupadas() {
      const short = s => s.replace(/^Semana\s+(\d{1,2})\s+(\d{4})$/, (_, w, y) => `Sem. ${w} '${y.slice(-2)}`);

      this.chartOptions1 = [{
        name: 'Disponibilidad',
        data: this.datosAgrupados.periodos.map(p => ({
          x: p.etiqueta,
          y: Number(p.disponibilidad.toFixed(2)),
          fullLabel: `${p.fechaInicio} — ${p.fechaFin}` // si quieres tooltip más descriptivo
        }))
      }];
      this.chartOptions2 = [{
        name: 'Rendimiento',
        data: this.datosAgrupados.periodos.map(p => ({
          x: p.etiqueta,
          y: Number(p.rendimiento.toFixed(2)),
          fullLabel: `${p.fechaInicio} — ${p.fechaFin}` // si quieres tooltip más descriptivo
        }))
      }];
      this.chartOptions3 = [{
        name: 'Calidad',
        data: this.datosAgrupados.periodos.map(p => ({
          x: p.etiqueta,
          y: Number(p.calidad.toFixed(2)),
          fullLabel: `${p.fechaInicio} — ${p.fechaFin}` // si quieres tooltip más descriptivo
        }))
      }];
      this.chartOptions4 = [{
        name: 'OEE',
        data: this.datosAgrupados.periodos.map(p => ({
          x: p.etiqueta,
          y: Number(p.oee.toFixed(2)),
          fullLabel: `${p.fechaInicio} — ${p.fechaFin}` // si quieres tooltip más descriptivo
        }))
      }];
      this.configurarGraficas();
    },
    
    configurarGraficas() {
      const opcionesBase = {
        chart: {
          type: 'bar',
          height: 240,
          toolbar: {
            show: false
          }
        },
        plotOptions: { bar: { columnWidth: '45%', borderRadius: 4 } },
        xaxis: {
          type: 'category',
          labels: {
            rotate: -25,
            trim: true,
            hideOverlappingLabels: true
          },
          tickPlacement: 'between',
        },
        yaxis: {
          min: 0, max: 100, tickAmount: 5,
          labels: { formatter: val => `${val}%` }
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          x: {
            formatter: (val, opts) => {
              const p = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
              return p.fullLabel || val;
            }
          },
          y: { formatter: val => `${val}%` }
        }
      };
      
      this.serie1 = { ...opcionesBase, colors: ['#118dff'] };
      this.serie2 = { ...opcionesBase, colors: ['#ff8410'] };
      this.serie3 = { ...opcionesBase, colors: ['#10ff60'] };
      this.serie4 = { ...opcionesBase, colors: ['#ff372b'] };
    },
    
    obtenerDatos() {
      if (this.validate()) return;
      
      this.cargando = true;
      this.cargandoData = true;
      
      axios
        .get(this.url)
        .then((response) => {
          this.datos = response.data || {};
          this.procesarDatosAgrupados(this.datos);
          this.renderizar = true;
          this.cargando = false;
          this.cargandoData = false;
          this.viewData = true;
        })
        .catch((error) => {
          console.error(error);
          this.cargando = false;
          this.cargandoData = false;
          this.error = true;
          this.errores = ['Error al obtener los datos. Por favor, intente nuevamente.'];
          
          if (error.response && error.response.status === 404) {
            this.errores = ['No se encontraron datos para el periodo seleccionado.'];
          }
        });
    },
    
    validate() {
      this.errores = [];
      
      if (this.tipoAgrupacion === 'semana') {
        if (!this.filtros.desde || !this.filtros.hasta) {
          this.errores.push('Debe seleccionar fecha de inicio y fin para agrupar por semanas.');
        }
      } else if (this.tipoAgrupacion === 'mes') {
        if (this.filtros.mesesSeleccionados.length === 0) {
          this.errores.push('Debe seleccionar al menos un mes para agrupar.');
        }
      }
      
      this.error = this.errores.length > 0;
      return this.errores.length > 0;
    },
    
    descargarReporte(){
      var datetime = moment().format('YYYYMMDDHHmmss');
      this.$utils.axios.downloadFile(this.url2("/OEEV2/OEEReportTurnos"),'GET','reporte-oee-'+datetime+'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    },
    
    url2(path) {
      var url = `${path}?`;
      
      if (this.tipoAgrupacion === 'semana') {
        url += `Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
      } else {
        const { desde, hasta } = this.obtenerRangoFechasMeses();
        url += `Desde=${desde}&Hasta=${hasta}`;
      }
      
      url += `&TipoAgrupacion=${this.tipoAgrupacion}`;
      url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos, "IdsTurnos", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsAreas, "IdsAreas", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsOTS, "IdsOTS", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos, "IdsArticulos", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias, "IdsMaquinasInstancias", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas, "IdsPersonas", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsClientes, "IdsClientes", false);
      
      return url;
    },
    
    resetCampo(posicion) {
      switch (posicion) {
        case 1:
          this.filtros.idsTurnos = [];
          break;
        case 2:
          this.filtros.idsAreas = [];
          break;
        case 3:
          this.filtros.idsOTS = [];
          break;
        case 4:
          this.filtros.idsArticulos = [];
          break;
        case 5:
          this.filtros.idsMaquinaInstancias = [];
          break;
        case 6:
          this.filtros.idsPersonas = [];
          break;
        case 7:
          this.filtros.idsClientes = [];
          break;
      }
    },
    
    initialize() {
      this.getTurnos();
      this.getAreas();
      this.getOTS();
      this.getArticulos();
      this.getMaquinasIns();
      this.getOperadores();
      this.getClientes();
      
      const añoActual = new Date().getFullYear();
      for (let i = añoActual - 2; i <= añoActual; i++) {
        this.añosDisponibles.push(i);
      }
    },
    
    getTurnos() {
      axios.get("/Turnos")
        .then((response) => {
          this.turnos = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    getAreas() {
      axios.get("/Areas")
        .then((response) => {
          this.areas = response.data.filter(a => a.idArea > 1);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    getOTS() {
      axios.get(`/TrabajoOrdenes/TrabajoOrdenHeaders?soloEnProgreso=${false}`)
        .then((response) => {
          this.ots = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    getArticulos() {
      axios.get("/Articulos/OTS")
        .then((response) => {
          this.articulos = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    getMaquinasIns() {
      axios.get("/MaquinaInstancias")
        .then(response => {
          this.maquinasIns = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    
    getOperadores() {
      axios.get("/Personas/Operadores")
        .then((response) => {
          this.operadores = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    getClientes() {
      axios.get("/Clientes")
        .then(response => {
          response.data.unshift({
            idCliente: -1,
            nombre: this.nombreEmpresa,
          });
          this.clientes = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  watch: {
    semanas: {
      deep: true,
      handler(v = []) {
        this.setRangeFromWeeks(v);
        this.filtros.semanasSeleccionadas = v.map(w => ({
          year: w.isoYear,
          week: w.isoWeek,
          desde: w.start,
          hasta: w.end,
          etiqueta: `Sem. ${String(w.isoWeek).padStart(2,'0')} '${String(w.isoYear).slice(-2)}`
        }));
      }
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>

